import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { Dedupe } from "@sentry/integrations";
import Animaker from './components/App'
import { applyMiddleware, createStore } from 'redux'
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga'
import reducer from './reducers'
import {watchLoadProject} from './sagas';
import {composeWithDevTools} from 'redux-devtools-extension';
import reduxCatch from 'redux-catch';
import { errorlog } from './helpers/ErrorLogService';
import undoMiddleware from './undoMiddleware';
import {autosaveMiddleware} from './autosaveMiddleware';
import { APIURIS } from "./config/app.json";
import ErrorHandler from './helpers/ErrorHandler';


if(APIURIS.current !== "dev"){
  Sentry.init({
    release: "20210728.01",
    // Client's DSN.
    dsn: 'https://f64255e362cd433eb96977e1ea34d803@o219485.ingest.sentry.io/5501742',
    // An array of strings or regexps that'll be used to allow specific errors based on their origin url
    allowUrls: [APIURIS[APIURIS.current]],
    // Debug mode with valuable initialization/lifecycle informations.
    debug: false,
    // Whether SDK should be enabled or not.
    enabled: true,
    // An environment identifier.
    environment: APIURIS.current,
    integrations: [
      new Dedupe(),
    ],
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications"
    ]
  });
  
  Sentry.configureScope(scope => {
    scope.setTags({
      projectId: document.querySelector('#root').dataset.id,
      teamId: document.querySelector('#root').dataset.teamid,
      userId: document.querySelector('#root').dataset.userid
    });
  });
   }

const sagaMiddleware = createSagaMiddleware();

// addLocaleData([...en, ...fr]);
function errorHandler(error, getState, lastAction, dispatch) {
  // var errorInfo = {currentState: getState(), lastAction: lastAction} // optionally dispatch an action due to the error using the dispatch parameter
  errorlog(error, lastAction, "Redux-errorHandler");
}

var root = document.getElementById('root');
const store = createStore(reducer,applyMiddleware(reduxCatch(errorHandler),undoMiddleware,sagaMiddleware,autosaveMiddleware));
// const store = createStore(reducer,composeWithDevTools({trace: true})(applyMiddleware(reduxCatch(errorHandler),undoMiddleware,sagaMiddleware,autosaveMiddleware)));
sagaMiddleware.run(watchLoadProject, {'projectId' : root.dataset.id, 'userId': root.dataset.userid, 'teamId': root.dataset.teamid, lang: root.dataset.language,'mode':root.dataset.apptype})

ReactDOM.render(
    <Provider store={store}>
      <ErrorHandler component="Animaker">
      <Animaker projectid={root.dataset.id} projectUsr={root.dataset.user} appType = {root.dataset.type} userId = {root.dataset.userid} teamId = {root.dataset.teamid} mode={root.dataset.apptype} projectUsrImg = {root.dataset.img} defaultView = {root.dataset.view !== undefined?root.dataset.view:"full"}
       langToLoad={root.dataset.language} userStatus={root.dataset.active} isEdit = { root.dataset.isedit !== undefined && root.dataset.isedit === "1" }  sampleTourDemo={root.dataset.sample} sampleSrc={root.dataset.src}/>
      </ErrorHandler>
    </Provider>,
  document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js